const React = require("react");

function AppleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M12.34,6.87C12.15,4.79,13.99,2.16,16.56,2 C16.91,4.19,14.85,6.88,12.34,6.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M19.53,17.03c-0.2,0.71-0.52,1.41-0.94,2.17 c-0.62,1.13-1.3,1.83-1.87,2.27c-0.66,0.52-1.53,0.62-2.3,0.32c-0.18-0.07-0.39-0.15-0.61-0.25c-0.86-0.34-1.8-0.35-2.66-0.02 c-0.24,0.1-0.5,0.2-0.79,0.3c-0.86,0.35-1.83,0.17-2.52-0.47c-1.77-1.67-3.36-4.66-3.36-8.04c0-4.2,3.15-5.48,4.56-5.48 c0.77,0,1.58,0.29,2.17,0.57c0.57,0.27,1.23,0.27,1.82,0.02c0.69-0.29,1.63-0.59,2.51-0.59c1.6,0,2.78,0.77,3.53,1.78 c-1.19,0.74-1.98,2.07-1.98,3.58C17.07,14.89,18.08,16.37,19.53,17.03z"
  })));
}

module.exports = AppleIcon;